import { useTranslation } from 'react-i18next';
import { APP_URL } from '@/config';

// Chinchetas decorativas flotando sobre el fondo (posición, retardo y duración variados).
const PINS = [
  { top: '22%', left: '12%', delay: '0s', dur: '7s' },
  { top: '34%', left: '82%', delay: '1.2s', dur: '6s' },
  { top: '68%', left: '20%', delay: '0.6s', dur: '8s' },
  { top: '74%', left: '70%', delay: '1.8s', dur: '6.5s' },
  { top: '46%', left: '50%', delay: '0.9s', dur: '7.5s' },
];

export function Hero() {
  const { t } = useTranslation();

  return (
    <section id="top" className="topo relative flex min-h-screen items-center overflow-hidden">
      {/* Capa de líneas de contorno a la deriva */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 animate-drift opacity-60"
        style={{
          backgroundImage:
            'repeating-radial-gradient(circle at 60% 30%, transparent 0, transparent 54px, rgba(192,147,90,0.06) 55px, rgba(192,147,90,0.06) 56px)',
        }}
      />

      {/* Chinchetas flotantes */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        {PINS.map((p, i) => (
          <span
            key={i}
            className="map-pin animate-float"
            style={{ top: p.top, left: p.left, animationDelay: p.delay, animationDuration: p.dur }}
          />
        ))}
      </div>

      {/* Velo inferior para fundir con la siguiente sección */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-clay-950 to-transparent" />

      <div className="relative mx-auto w-full max-w-4xl px-5 text-center">
        <span
          className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-amber-glow/30 bg-amber-glow/10 px-4 py-1.5 text-xs font-medium uppercase tracking-widest text-amber-glow"
          style={{ animationDelay: '0.05s' }}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-amber-glow" />
          {t('hero.eyebrow')}
        </span>

        <h1 className="mt-7 font-display text-[2rem] font-semibold leading-[1.08] tracking-tight text-clay-50 sm:text-6xl md:text-7xl">
          <span className="animate-fade-up block" style={{ animationDelay: '0.15s' }}>
            {t('hero.title_1')}
          </span>
          <span
            className="text-gradient animate-fade-up block"
            style={{ animationDelay: '0.3s' }}
          >
            {t('hero.title_2')}
          </span>
        </h1>

        <p
          className="animate-fade-up mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-clay-200"
          style={{ animationDelay: '0.45s' }}
        >
          {t('hero.subtitle')}
        </p>

        <div
          className="animate-fade-up mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row"
          style={{ animationDelay: '0.6s' }}
        >
          <a href={APP_URL} className="btn-primary w-full sm:w-auto">
            {t('hero.cta_primary')}
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a href="#features" className="btn-ghost w-full sm:w-auto">
            {t('hero.cta_secondary')}
          </a>
        </div>
      </div>

      {/* Indicador de scroll */}
      <a
        href="#features"
        className="animate-fade-up absolute bottom-8 left-1/2 -translate-x-1/2 text-xs uppercase tracking-widest text-clay-300/70 transition hover:text-amber-glow"
        style={{ animationDelay: '0.9s' }}
      >
        <span className="flex flex-col items-center gap-2">
          {t('hero.scroll')}
          <span className="flex h-9 w-5 justify-center rounded-full border border-clay-300/30 pt-1.5">
            <span className="h-1.5 w-1 animate-float rounded-full bg-amber-glow" />
          </span>
        </span>
      </a>
    </section>
  );
}
